import InputGroup from 'antd/es/input/Group';

export default InputGroup;
